import { composeU } from '@bem-react/core';

import BaseSearch from 'client/common/components/search';

import { withSearchTypeMenu } from './_type/search_type_menu';
import { withSearchTypeSidebar } from './_type/search_type_sidebar';

const Search = composeU(withSearchTypeMenu, withSearchTypeSidebar)(BaseSearch);

export default Search;
